import React from 'react';
import Spacing from '../Spacing';

// On phones (≤767px) both spacers use the 64px section rhythm used site-wide.
// A page that starts without a banner should pass topSm={112} to clear the fixed header.
export default function Section({
  topMd = '_',
  topLg = '_',
  topXl = '_',
  topSm = 64,
  bottomMd = '_',
  bottomLg = '_',
  bottomXl = '_',
  bottomSm = 64,
  children,
  ...props
}) {
  return (
    <section {...props}>
      <Spacing md={topMd} lg={topLg} xl={topXl} sm={topSm} />
      {children}
      <Spacing md={bottomMd} lg={bottomLg} xl={bottomXl} sm={bottomSm} />
    </section>
  );
}
